import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import UsersPage from "../pages/users/UsersPage";
import UserTypesPage from "../pages/userTypes/UserTypesPage";
import LoginScreen from "../pages/login";
import DashboardLayout from "../layouts/dashboardLayout";
import ProtectedRoute from "./ProjectedRouter";
import ResetPasswordPage from "../pages/resetPassword/ResetPassword";
import PromotersPage from "../pages/promotors/PromotorsPage";
import PromoterDetailsPage from "../pages/promotors/PromoterDetailsPage";
import NoAccess from "../pages/noAccess/NoAccess";
import ArtistsPage from "../pages/artists/ArtistPage";
import ArtistDetailsPage from "../pages/artists/ArtistDetailsPage";
import CompaniesInfoPage from "../pages/companiesInfo/CompaniesPage";
import CompanyDetailsPage from "../pages/companiesInfo/CompantDetailsPage";
import DocumentPage from "../pages/documents/DocumentPage";
import EventPage from "../pages/events/EventsPage";
import DocumentSignPage from "../pages/documents/DocumentSignPage";
import GeneratedDocumentsPage from "../pages/documents/GeneratedDocuments";
import BookingsPage from "../pages/bookings/BookingsPage";
import BookingCreatePage from "../pages/bookings/BookingsCreatePage";
import BookingDetailsPage from "../pages/bookings/BookingDetailPage";
import ClientsPage from "../pages/clients/ClientsPage";
import LandingPages from "../pages/landingPages/landingPages";
import PublicLandingPage from "../pages/landingPages/publicLandingPage";
import LandingPageSubmissions from "../pages/landingPages/landingPageSubmissions";
import ShortLinksPage from "../pages/shortLinks/shortLinksPage";
import EventDetailPage from "../pages/events/EventDetailsPage";
import PixelsPage from "../pages/pixels/pixelsPage";
import Events from "../pages/ticketSelling/events";
import EventDetails from "../pages/ticketSelling/eventDetails";
import SaleTagsPage from "../pages/salesTags/SalesTagPage";
import Checkout from "../pages/ticketSelling/checkout";
import Payment from "../pages/ticketSelling/payment";
import OrderStatus from "../pages/ticketSelling/orderStatus";
import Register from "../pages/ticketSelling/register";
import AuthPage from "../pages/ticketSelling/authPage";
import UserDashboard from "../pages/ticketSelling/dashboard";
import ResetPassword from "../pages/ticketSelling/resetPassword";
import NotFound from "../pages/notFound/NotFoundPage";
import OrdersPage from "../pages/orders/OrdersPage";
import OrderDetailPage from "../pages/orders/OrderDetailsPage";
import TermsAndConditions from "../pages/ticketSelling/terms";
import { useEffect } from "react";
import GeneralMenuBar from "../pages/barMenus/generalBarMenu";
import EmailsPage from '../pages/emails/EmailsPage';
import PayeesPage from "../pages/payees/PayeesPage";
import FinanceDashboardPage from "../pages/financial/FinanceDashboard";
import CompanyExpensesPage from "../pages/expenses/CompanyExpensesPage";
import FAQPage from '../pages/ticketSelling/faqPage';

const AppRouter = () => {

  function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
    return null;
  }

  return (
    <BrowserRouter>
     <ScrollToTop />
      <Routes>
        {/* Public */}
        <Route path="/" element={<LoginScreen />} />

        {/* Protected Dashboard Routes */}
        <Route
          path="/dashboard/users"
          element={
            <ProtectedRoute permission="users">
              <DashboardLayout>
                <UsersPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/no-access"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <NoAccess />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/user-types"
          element={
            <ProtectedRoute permission="user_types">
              <DashboardLayout>
                <UserTypesPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/companies"
          element={
            <ProtectedRoute permission="companies_info">
              <DashboardLayout>
                <CompaniesInfoPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/companies/:id"
          element={
            <DashboardLayout>
              <CompanyDetailsPage />
            </DashboardLayout>
          }
        />

        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route
          path="/dashboard/promoters"
          element={
            <ProtectedRoute permission="promoters">
              <DashboardLayout>
                <PromotersPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/promoters/:id"
          element={
            <DashboardLayout>
              <PromoterDetailsPage />
            </DashboardLayout>
          }
        />

        <Route
          path="/dashboard/artists"
          element={
            <ProtectedRoute permission="artists">
              <DashboardLayout>
                <ArtistsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/artists/:id"
          element={
            <ProtectedRoute permission="artists">
              <DashboardLayout>
                <ArtistDetailsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/documents"
          element={
            <ProtectedRoute permission="documents">
              <DashboardLayout>
                <DocumentPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route path="/documents/:id/sign" element={<DocumentSignPage />} />

        <Route
          path="/dashboard/all-documents"
          element={
            <ProtectedRoute permission="documents">
              <DashboardLayout>
                <GeneratedDocumentsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/events"
          element={
            <ProtectedRoute permission="events">
              <DashboardLayout>
                <EventPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/events/:id"
          element={
            <ProtectedRoute permission="events">
              <DashboardLayout>
                <EventDetailPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/tickets"
          element={
            <ProtectedRoute permission="tickets">
              <DashboardLayout>
                <EventPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/bookings"
          element={
            <ProtectedRoute permission="bookings">
              <DashboardLayout>
                <BookingsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/bookings/create"
          element={
            <ProtectedRoute permission="bookings">
              <DashboardLayout>
                <BookingCreatePage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/bookings/:id"
          element={
            <ProtectedRoute permission="bookings">
              <DashboardLayout>
                <BookingDetailsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/clients"
          element={
            <ProtectedRoute permission="clients">
              <DashboardLayout>
                <ClientsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/landing-pages"
          element={
            <ProtectedRoute permission="landing_pages">
              <DashboardLayout>
                <LandingPages />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/landing-pages/:id/submissions"
          element={
            <ProtectedRoute permission="landing_pages">
              <DashboardLayout>
                <LandingPageSubmissions />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/shorten-links"
          element={
            <ProtectedRoute permission="links">
              <DashboardLayout>
                <ShortLinksPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/pixels"
          element={
            <ProtectedRoute permission="pixels">
              <DashboardLayout>
                <PixelsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/orders"
          element={
            <ProtectedRoute permission="orders">
              <DashboardLayout>
                <OrdersPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/orders/:id"
          element={
            <ProtectedRoute permission="orders">
              <DashboardLayout>
                <OrderDetailPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/sales-tags"
          element={
            <ProtectedRoute permission="sales_tags">
              <DashboardLayout>
                <SaleTagsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/emails"
          element={
            <ProtectedRoute permission="emails">
              <DashboardLayout>
                <EmailsPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/financial"
          element={
            <ProtectedRoute permission="financial">
              <DashboardLayout>
                <FinanceDashboardPage/>
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/payees"
          element={
            <ProtectedRoute permission="payees">
              <DashboardLayout>
                <PayeesPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/company-expenses"
          element={
            <ProtectedRoute permission="company-expenses">
              <DashboardLayout>
                <CompanyExpensesPage />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route path="/tickets-store/checkout" element={<Checkout />} />

        <Route path="/tickets-store/payment" element={<Payment />} />

        <Route path="/tickets-store/order-status" element={<OrderStatus />} />

        <Route path="/tickets-store/register" element={<Register />} />

        <Route path="/tickets-store/auth" element={<AuthPage />} />

        <Route path="/tickets-store/user" element={<UserDashboard />} />

        <Route path="/tickets-store" element={<Events />} />

        <Route
          path="/tickets-store/reset-password"
          element={<ResetPassword />}
        />

        <Route path="/tickets-store/terms" element={<TermsAndConditions />} />

        <Route path="/tickets-store/faq" element={<FAQPage />} />

        <Route path="/tickets-store/events/:id" element={<EventDetails />} />

        <Route path="/bar-menu/general-menu-bar" element={<GeneralMenuBar />} />

        <Route path="/:slug" element={<PublicLandingPage />} />

        {/* Fallback */}
        {/* <Route path="*" element={<Navigate to="/dashboard/users" replace />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
